import { connect } from 'react-redux'
import * as selector from '../../state/transfer-drive-files/selector'
import * as action from '../../state/transfer-drive-files/action'
import TransferDriveFiles from './TransferDriveFiles'


const mapStateToProps = (state, props) => {
    return {
        fileList: selector.selectFileList(state),
    }
}


const mapDispatchToProps = {
    getScanFolderContent: action.getScanFolderContent,
}


export default connect(mapStateToProps, mapDispatchToProps)(TransferDriveFiles)



// WEBPACK FOOTER //
// ./src/modules/customer/component/task-widget/TransferDriveFilesContainer.js